import ScreenVerify from './screen-verify';

export default ScreenVerify;
